import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Notice, Separator, Tooltip, TooltipToggle } from 'telia-front-react';

import InvoiceSettingsChangeLogStore from '../../../stores/InvoiceSettingsChangeLogStore';
import { ITranslateStore } from '../../../stores/TranslateStore';
import { formatDate, formatTime } from '../../../util/DateUtil';

interface IInvoiceChangeLogNoticeProps {
  translateStore?: ITranslateStore;
  invoiceSettingsChangeLogStore?: InvoiceSettingsChangeLogStore;
}

@inject('translateStore', 'invoiceSettingsChangeLogStore')
@observer
export default class InvoiceChangeLogNotice extends React.Component<IInvoiceChangeLogNoticeProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const changeLog = this.props.invoiceSettingsChangeLogStore.changeLog;

    if (changeLog.isFinished && !!changeLog.payload) {
      return (
        <>
          <Separator spacing="xsmall" color="invisible" />
          <Notice size="small" id="invoice-settings-modal.change-log-notice">
            {`${translate('invoices.invoice-settings-modal.change-log.notice.first-half', {
              date: formatDate(changeLog.payload.dateTime),
              time: formatTime(changeLog.payload.dateTime)
            } as any)} `}
            {changeLog.payload.dealerUsername ? (
              <Tooltip
                fixedWidth={false}
                referenceElement={<TooltipToggle id={'invoice-settings-change-log-tooltip'}>{changeLog.payload.actorDisplayName}</TooltipToggle>}
              >
                <div className={'text-employee'}>
                  {translate('invoices.invoice-settings-modal.change-log.notice.tooltip.username', {
                    username: changeLog.payload.dealerUsername
                  } as any)}
                </div>
              </Tooltip>
            ) : (
              <>{changeLog.payload.actorDisplayName}</>
            )}
            {` ${translate('invoices.invoice-settings-modal.change-log.notice.second-half')}`}
          </Notice>
        </>
      );
    }
    return null;
  }
}
